import React from 'react';


const Check = ({ className }) => {
  

  return (
    <div className={`section-main ${className || ''} pt-5`} style={{ padding: '2rem', backgroundColor: 'lightblue', height: '100vh' }}>

      <h3 className="text-center fw-bold mb-4">Check</h3>

    </div>
  );
};

export default Check;